export const CHECK_ROOM_BOOKING_REQUEST = "CHECK_ROOM_BOOKING_REQUEST";
export const CHECK_ROOM_BOOKING_SUCCESS = "CHECK_ROOM_BOOKING_SUCCESS";
export const CHECK_ROOM_BOOKING_FAIL = "CHECK_ROOM_BOOKING_FAIL";
export const CHECK_ROOM_BOOKING_RESET = "CHECK_ROOM_BOOKING_RESET";

export const CREATE_BOOKING_REQUEST = "CREATE_BOOKING_REQUEST";
export const CREATE_BOOKING_SUCCESS = "CREATE_BOOKING_SUCCESS";
export const CREATE_BOOKING_FAIL = "CREATE_BOOKING_FAIL";
export const CREATE_BOOKING_RESET = "CREATE_BOOKING_RESET";

export const GET_BOOKED_DATES_REQUEST = "GET_BOOKED_DATES_REQUEST";
export const GET_BOOKED_DATES_SUCCESS = "GET_BOOKED_DATES_SUCCESS";
export const GET_BOOKED_DATES_FAIL = "GET_BOOKED_DATES_FAIL";

export const GET_MY_BOOKINGS_REQUEST = "GET_MY_BOOKINGS_REQUEST";
export const GET_MY_BOOKINGS_SUCCESS = "GET_MY_BOOKINGS_SUCCESS";
export const GET_MY_BOOKINGS_FAIL = "GET_MY_BOOKINGS_FAIL";

export const FETCH_BOOKINGS_REQUEST = "FETCH_BOOKINGS_REQUEST";
export const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
export const FETCH_BOOKINGS_FAIL = "FETCH_BOOKINGS_FAIL";

export const DELETE_BOOKING_REQUEST = "DELETE_BOOKING_REQUEST";
export const DELETE_BOOKING_SUCCESS = "DELETE_BOOKING_SUCCESS";
export const DELETE_BOOKING_FAIL = "DELETE_BOOKING_FAIL";